module.exports = __webpack_public_path__ + "img/dropdown_nonactive.20187595.svg";